var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M76 44H20C15.5817 44 12 47.5817 12 52V80C12 84.4183 15.5817 88 20 88H76C80.4183 88 84 84.4183 84 80V52C84 47.5817 80.4183 44 76 44Z","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M28 44V28C28 22.6957 30.1071 17.6086 33.8579 13.8579C37.6086 10.1071 42.6957 8 48 8C53.3043 8 58.3914 10.1071 62.1421 13.8579C65.8929 17.6086 68 22.6957 68 28V44","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Lock.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Lock;

Lock.default = Lock;
